module.exports = __webpack_public_path__ + "media/images/locate-d42ba522dc7631f7a21045c88a120e54.png";